export const resetStore = ({
  clearRedirect,
}: { clearRedirect?: boolean } = {}) => ({
  type: 'store/reset',
  payload: { clearRedirect },
});
